import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useCustomControl, listenPanelExpanded, CUSTOM_CONTROL_INPUT_CHECKBOX_CLASS_NAME } from "@devowl-wp/customize";
import { __ } from "../../../utils";
import { useStores } from "../../../store";
import { useUpsellModal } from "@devowl-wp/react-cookie-banner-admin";
import { usePlainCss } from "@devowl-wp/react-utils";
function useProModalMobileExperience() {
    return useUpsellModal({
        title: __("Want to optimize the cookie banner for mobile users?"),
        testDrive: true,
        feature: "mobile-experience",
        assetName: __("pro-modal/mobile-optimization.png"),
        description: __("Cookie banners are a necessary evil that takes up a lot of space, especially on smartphones. With mobile optimization you can customize the cookie banner so that it is more discreet and at the same time easy to read on smartphones.")
    });
}
const MobileSwitcherControl = ()=>{
    const { optionStore: { others: { customizeIdsBanner: { sections: { mobile: mobileSectionId } } } } } = useStores();
    const { value, setValue } = useCustomControl();
    const [selectedDimensions, setSelectedDimensions] = useState("375,812");
    const [isSectionOpen, setIsSectionOpen] = useState(false);
    const { isPro, modal, tag } = useProModalMobileExperience();
    useEffect(()=>{
        listenPanelExpanded(mobileSectionId, setIsSectionOpen);
    }, []);
    const [deviceWidth, deviceHeight] = selectedDimensions.split(",").map(Number);
    usePlainCss(value && isSectionOpen ? `#customize-preview {
    width: ${deviceWidth}px !important;
    height: ${deviceHeight}px !important;
    margin: auto 0 auto calc(${deviceWidth}px / 2 * -1) !important;
    max-height: 100%;
    max-width: 100%;
    left: 50%;
}

#customize-footer-actions .devices-wrapper {
    display: none;
}` : "");
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            modal,
            /*#__PURE__*/ _jsxs("label", {
                children: [
                    /*#__PURE__*/ _jsx("input", {
                        className: CUSTOM_CONTROL_INPUT_CHECKBOX_CLASS_NAME,
                        type: "checkbox",
                        disabled: !isPro,
                        value: "1",
                        checked: isPro ? value : false,
                        onChange: ()=>setValue(!value)
                    }),
                    __("Enable mobile optimization"),
                    " ",
                    tag
                ]
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "description customize-control-description",
                style: {
                    marginTop: 5
                },
                children: __("To ensure that the cookie banner does not take up too much space on mobile devices, its display can be reduced for this class of device.")
            }),
            value && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "customize-control-title",
                        style: {
                            marginTop: 10
                        },
                        children: __("Simulate device in preview")
                    }),
                    /*#__PURE__*/ _jsxs("select", {
                        value: selectedDimensions,
                        onChange: (e)=>setSelectedDimensions(e.target.value),
                        children: [
                            /*#__PURE__*/ _jsx("option", {
                                value: "411,731",
                                children: "Pixel 2"
                            }),
                            /*#__PURE__*/ _jsx("option", {
                                value: "411,823",
                                children: "Pixel 2 XL"
                            }),
                            /*#__PURE__*/ _jsx("option", {
                                value: "320,568",
                                children: "iPhone 5/SE"
                            }),
                            /*#__PURE__*/ _jsx("option", {
                                value: "375,667",
                                children: "iPhone 6/7/8"
                            }),
                            /*#__PURE__*/ _jsx("option", {
                                value: "414,736",
                                children: "iPhone 6/7/8 Plus"
                            }),
                            /*#__PURE__*/ _jsx("option", {
                                value: "375,812",
                                children: "iPhone X"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export { MobileSwitcherControl, useProModalMobileExperience };
